import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px grid grid-cols-2 gap-8" }
const _hoisted_6 = { class: "col-span-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "City ID", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "City Code", -1)
const _hoisted_10 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "City Name", -1)
const _hoisted_12 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Origin Transit", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Destination Transit", -1)
const _hoisted_16 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Min. SLA", -1)
const _hoisted_18 = { class: "my-1 text-black-lp-300" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Max. SLA", -1)
const _hoisted_20 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Timezone", -1)
const _hoisted_22 = { class: "my-1 text-black-lp-300" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Free Trade Zone", -1)
const _hoisted_24 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Sunday Delivery", -1)
const _hoisted_26 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_27 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_28 = { class: "py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Rute", -1)
const _hoisted_30 = { class: "my-1 text-black-lp-300" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "capitalize" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300" }
const _hoisted_36 = { class: "text-gray-lp-500" }
const _hoisted_37 = { class: "py-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_39 = { class: "my-1 text-black-lp-300" }
const _hoisted_40 = { class: "text-gray-lp-500" }
const _hoisted_41 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading === true)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.dataDetail.name) + " - " + _toDisplayString(_ctx.dataDetail.code), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchCityData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetail.id), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.dataDetail.code), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_11,
                  _createVNode("div", _hoisted_12, _toDisplayString(_ctx.dataDetail.name.toLowerCase()), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.dataDetail.originTransit !== ""
                ? _ctx.dataDetail.originTransit.toLowerCase()
                : "-"), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.dataDetail.destinationTransit !== ""
                ? _ctx.dataDetail.destinationTransit.toLowerCase()
                : "-"), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.dataDetail.minimalSla), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.dataDetail.maximalSla), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_21,
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.dataDetail.timezone), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_23,
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.dataDetail.freeTradeZone), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.dataDetail.sundayDelivery === "0" ? "Tidak" : "Ya"), 1)
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.isActive.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.isActive.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.dataDetail.isActive.toLowerCase()), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDate(_ctx.dataDetail.createdAt)), 1),
                  _createVNode("div", _hoisted_36, _toDisplayString(_ctx.dataDetail.createdBy), 1)
                ]),
                _createVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode("div", _hoisted_39, _toDisplayString(_ctx.dataDetail.updateAt === "0001-01-01T00:00:00Z"
                ? _ctx.formatDate(_ctx.dataDetail.createdAt)
                : _ctx.formatDate(_ctx.dataDetail.updateAt)), 1),
                  _createVNode("div", _hoisted_40, _toDisplayString(_ctx.dataDetail.updatedBy), 1)
                ]),
                _createVNode("div", _hoisted_41, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = () => _ctx.goEdit(_ctx.id)),
                        title: "Edit",
                        class: "px-8 bg-red-lp-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]))
}